import { LocalStorage } from "@stripe-internal/stripe-cookies";
import createLocalStorageEventListener from "./createLocalStorageEventListener";
const emptyConfig = {};
const configMap = new WeakMap();
export default function initLocalStorage(config, reports) {
    const potentialLocalStorageObj = configMap.get(config !== null && config !== void 0 ? config : emptyConfig);
    if (potentialLocalStorageObj) {
        return potentialLocalStorageObj;
    }
    const localStorage = new LocalStorage({
        enforcementMode: config === null || config === void 0 ? void 0 : config.enforcementMode
    });
    const eventListener = createLocalStorageEventListener(reports);
    const cookieObj = {
        localStorage,
        eventListener
    };
    configMap.set(config !== null && config !== void 0 ? config : emptyConfig, cookieObj);
    return cookieObj;
}

//# sourceMappingURL=initLocalStorage.js.map